export default __webpack_public_path__ + "static/media/20.74672bb2.gif";